export default {
  container: {
    width: '100%',
    marginBottom: '16px',
  },
  sectionHeader: {
    padding: '4px',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    height: '24px',
    color: (theme) => theme.palette.grays.gray700,
    fontSize: '16px',
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '20px',
    color: (theme) => theme.palette.grays.gray700,
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  primaryButton: {
    textTransform: 'none',
    minWidth: 'auto',
    height: '32px',
    padding: '0 16px',
  },
  secondaryButton: {
    textTransform: 'none',
    minWidth: 'auto',
    height: '32px',
  },
  chevronButton: {
    padding: '2px',
    color: (theme) => theme.palette.grays.gray700,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  contentContainer: {
    padding: '0',
  },
};
